import { isNil } from 'lodash'

import { FieldBoolean } from './components/Boolean'
import { FieldDigit } from './components/Digit'
import { FieldStatus } from './components/Status'
import { FieldText } from './components/Text'
import { ProFieldProps } from './interface'

export const ProField = (props: ProFieldProps) => {
  const { value, emptyText = '-' } = props

  if (isNil(value)) {
    return <span>{emptyText}</span>
  }

  if (props.type === 'text') {
    return <FieldText {...props} />
  }

  if (props.type === 'status') {
    return <FieldStatus {...props} />
  }

  if (props.type === 'boolean') {
    return <FieldBoolean {...props} />
  }

  if (props.type === 'digit') {
    return <FieldDigit {...props} />
  }

  console.warn(`[ProField] type ${(props as any).type} is not supported`)

  return null
}
